import { render, staticRenderFns } from "./PrivatkundenPage.vue?vue&type=template&id=9ad99316&"
import script from "./PrivatkundenPage.vue?vue&type=script&lang=js&"
export * from "./PrivatkundenPage.vue?vue&type=script&lang=js&"
import style0 from "./PrivatkundenPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
